import React from 'react';
import styled from 'styled-components';

const SettingsContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Title = styled.h2`
  margin: 0 0 20px 0;
  color: #2c3e50;
`;

const SettingSection = styled.div`
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dee2e6;
  
  &:last-child {
    border-bottom: none;
  }
`;

const SectionTitle = styled.h3`
  margin: 0 0 15px 0;
  color: #2c3e50;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #2c3e50;
  font-weight: 500;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #3498db;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #3498db;
  }
`;

const SaveButton = styled.button`
  background-color: #2ecc71;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #27ae60;
  }
`;

const Settings = () => {
  return (
    <SettingsContainer>
      <Title>설정</Title>
      
      <SettingSection>
        {/* <SectionTitle>일반 설정</SectionTitle> */}
        <FormGroup>
          <Label>사이트 이름</Label>
          <Input type="text" defaultValue="CST Product Manager" />
        </FormGroup>
        <FormGroup>
          <Label>환율 설정</Label>
          <Input type="text" defaultValue="" />
        </FormGroup>
      </SettingSection>
      
      <SaveButton>설정 저장</SaveButton>
    </SettingsContainer>
  );
};

export default Settings;